import $ from 'jquery';
import { spin, breakpoints } from './_site';
// import { createAlert } from './window';
import { create as createSlider } from './slider';
require('jqueryCookie');

// const timeout = {};
// export const addFavourite = ($el) => {
//     var $submit = $el,
//         $submitAux = $el.children('span'),
//         svg = $el.find('svg'),
//         itemClass = 'favourite',
//         $list = $el.closest('[data-favourite-url]'),
//         $item = $el.closest('[data-pid]'),
//         data = {
//             pid: $item.data('pid')
//         },
//         url = $list.data('favourite-url'),
//         spinner = $.extend(true, {}, spin);
//
//     function toggleLoader(flag) {
//         if (flag) {
//             // add loader
//             $submit.addClass(itemClass + '--loading');
//             $submit.spin(spinner);
//         } else {
//             // remove loader
//             $submit.removeClass(itemClass + '--loading');
//             $submit.spin(false);
//         }
//     }
//
//     // loading
//     $.extend(spinner, {
//         color: '#000',
//         width: 4,
//         radius: 5
//     });
//
//     if ($el.hasClass(itemClass + '--active')) {
//         data.remove = 'true';
//     }
//
//     console.log(data);
//
//     // send data
//     $.ajax({
//         type: 'POST',
//         url: url,
//         data: data,
//         cache: false,
//         dataType: 'json',
//         beforeSend: function () {
//             toggleLoader(true);
//         },
//         success: function (response) {
//             console.log(response);
//
//             if (response.status) {
//                 if ($el.hasClass(itemClass + '--active')) {
//                     $el.removeClass(itemClass + '--active');
//                     $submitAux.html(' Add to wishlist').prepend(svg);
//
//                     // create alert
//                     createAlert(response, 'warning');
//
//                 } else if ($el.hasClass(itemClass)) {
//                     $el.addClass(itemClass + '--active');
//                     // $submitAux.html(' Remove from wishlist').prepend(svg);
//                     $submitAux.html(' Remove wishlist').prepend(svg);
//
//                     // create alert
//                     createAlert(response, 'success');
//                 }
//                 // updateView(response);
//             } else {
//                 // create alert
//                 createAlert(response, 'error');
//             }
//
//             // remove loader
//             toggleLoader(false);
//         },
//         error: function (response) {
//             // create alert
//             createAlert(response, 'error');
//             // remove loader
//             toggleLoader(false);
//         }
//     });
// };
export const initListStyle = () => {
    var $listStyles = $('[data-list]'),
        $selectedListStyle = $listStyles.is(':checked'),
        savedSelectedStyle = $.cookie('categoryGridType'),
        $savedListStyle =
            savedSelectedStyle != null
                ? $('[data-list][value=' + savedSelectedStyle + ']')
                : false;

    if ($savedListStyle && $savedListStyle.length) {
        $savedListStyle.prop('checked', true);
        changeListStyle($savedListStyle.first());
    } else if ($selectedListStyle.length) {
        changeListStyle($selectedListStyle.first());
    } else {
        changeListStyle($listStyles.first());
    }
};
export const changeListStyle = ($el) => {
    var $productList = $('#products-list'),
        value = $el.val(),
        listClass = 'product-grid--list';

    if ($productList.length) {
        $.cookie('categoryGridType', value);
        if (value == 'list') {
            $productList.addClass(listClass);
        } else {
            $productList.removeClass(listClass);
        }
    }
};
// export const getFilters = (ignore) => {
//     var filters = {},
//         $inputs = $('.filter-list__link--active');
//
//     $inputs.each(function () {
//         var $input = $(this),
//             value = $input.data('filter'),
//             key = $input.closest('.filter-list').data('key');
//             // name = $input.siblings('.field__value').text();
//
//         // ignore
//         if (ignore.indexOf(key) != -1) return;
//
//         if (typeof filters[key] === 'undefined' ) {
//             filters[key] = [];
//         }
//
//         filters[key].push(value);
//     });
//
//     return filters;
// };
// export const applyFiltersClasses = ($el) => {
//     var filterClass = 'filter-list__link',
//         filterClassActive = filterClass + '--active',
//         $filterContainer = $el.closest('.filters'),
//         $filters = $filterContainer.find('.' + filterClassActive);
//
//     // normal filter
//     if ($el.hasClass(filterClass)) {
//         $el.toggleClass(filterClassActive);
//     }
//     // clear filter
//     else if ($el.is('[data-clear-filter]')) {
//         $filters.removeClass(filterClassActive);
//     }
// };
// export const applyFilters = ($el, ignore) => {
//     var pageURL = $('#filters').data('url'),
//         data = {},
//         $sort = $('#sort-dropdown'),
//         $perPage = $('#display-dropdown'),
//         $rangePrice = $('#range-price'),
//         price,
//         initialPrice;
//
//     ignore = ignore || [];
//
//     applyFiltersClasses($el);
//
//     // price
//     if ($rangePrice.length) {
//         price = $rangePrice.val().split(',');
//         initialPrice = $rangePrice.data('min') + ',' + $rangePrice.data('max');
//     }
//
//     // sort
//     if ($sort.length) {
//         data.sort = $sort.val().split(',');
//     }
//
//     // per-page
//     if ($perPage.length) {
//         data.display = $perPage.val().split(',');
//     }
//
//     // price
//     if (ignore.indexOf('price') && price != initialPrice) {
//         data.min = price[0];
//         data.max= price[1];
//     }
//
//     // search
//     // data.search = $('#search-form').val().split(','); // movile is #responsive-search-form
//
//     // filters
//     data.filters = getFilters(ignore);
//     $.map(data.filters, function (val, key) {
//         data[key] = val;
//     });
//     delete data.filters;
//
//     // convert to string
//     $.map(data, function(val, i) {
//         // replace ,
//         data[i] = val.toString();
//
//         // remove empty values
//         if (!data[i]) {
//             delete data[i];
//         }
//     });
//
//     // convert to url format
//     data = $.param(data);
//
//     // replacing the non-standards way
//     data = data.replace(/=/g,'/');
//     data = data.replace(/&/g,'/');
//     data = data.replace(/%2C/g,'~');
//     data = data.replace(/%2F/g,'~~');
//
//     console.log(data);
//
//     window.location.href = pageURL + data;
// };
export const createProductSlider = () => {
    const config = {
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: breakpoints.md,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: breakpoints.sm,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    variableWidth: true
                },
            },
        ],
    };

    createSlider($('.products-slider'), config);
};
export const binds = ($el, ignore) => {
    // products
    createProductSlider();

    // ---------------- add favourite
    // $('#content').on('click.products', '[data-add-favourite]', function (event) {
    //     event.preventDefault();
    //     addFavourite($(this));
    // });

    // ---------------- change list
    $('[data-list]').on('click.products', function() {
        changeListStyle($(this));
    });

    initListStyle();

    // ---------------- change filter
    // $('button[data-filter]').on('click.products', function () {
    //     applyFilters($(this));
    // });
    // $('select[data-filter]').on('change.products', function () {
    //     applyFilters($(this));
    // });
    // $('[data-clear-filter]').on('click.products', function () {
    //     applyFilters($(this), [$(this).data('clear-filter')]);
    // });
    // $('#price-range').on('submit', function (event) {
    //     event.preventDefault();
    //     applyFilters($(this));
    // });
};
